module.exports = __webpack_public_path__ + "static/media/K1_GLOSS.8c13b95f.png";